import { feedbackWizardFlow } from './feedback.domain.js';
import { traverseReasonFlow, } from '../wizard-flow-utils.js';
export const feedbackStepComponentMap = {
    // Employee selection steps
    'employee-selection': 'EmployeeSelection',
    // Date selection
    'date-selection': 'DateSelection',
    // Single choice steps
    'reason-selection': 'ChoiceList',
    'praise-feedback-subject-selection': 'ChoiceList',
    'information-sharing-subject-selection': 'ChoiceList',
    'decision-making-feedback-subject': 'ChoiceList',
    'reporting-feedback-subject': 'ChoiceList',
    'other-information-feedback-subject': 'ChoiceList',
    'expectations-setting-subject-selection': 'ChoiceList',
    'collaboration-service-type': 'ChoiceList',
    'schedule-agreement-type': 'ChoiceList',
    'communication-type-selection': 'ChoiceList',
    'body-language-details': 'ChoiceList',
    'speech-tone-details': 'ChoiceList',
    'general-conduct-details': 'ChoiceList',
    'written-communication-framework-selection': 'ChoiceList',
    'body-language-framework-selection': 'ChoiceList',
    'general-framework-selection': 'ChoiceList',
    'verbal-expressions-framework-selection': 'ChoiceList',
    'additional-effects-details': 'ChoiceList',
    'praise-feedback-recipient-selection': 'ChoiceList',
    'praise-feedback-employee-selection': 'EmployeeSelection',
    // Text area steps
    'praise-feedback-subject-description': 'TextArea',
    'decision-making-details': 'TextArea',
    'reporting-details': 'TextArea',
    'other-information-details': 'TextArea',
    'other-information-details-no-framework': 'TextArea',
    'expectations-setting-details-with-framework': 'TextArea',
    'expectations-setting-details-no-framework': 'TextArea',
    'collaboration-service-description': 'TextArea',
    'written-messages-description': 'TextArea',
    'schedule-agreement-description': 'TextArea',
    'verbal-expressions-description': 'TextArea',
    // Range steps
    'goal-impact-range': 'Range',
    // Multiple choice steps
    'additional-effects': 'EffectsChoiceList',
    // Goals and company values
    'goal-selection': 'GoalsChoice',
    'company-values': 'CompanyValuesChoice',
    // review step
    'interaction-description': 'TextArea',
};
/**
 * Get all answers in the reason flow between reason-selection and goal-selection.
 * Returns an array of step-answer pairs showing the complete user journey through the reason flow.
 *
 * @param answers - The wizard answers to traverse
 * @param translateFn - Optional translation function for formatting questions and answers
 * @param formatContext - Optional context for formatting (employee info, date formatter)
 * @returns Array of objects containing stepId, answer, and optionally formattedQuestion and formattedAnswer
 *
 * @example
 * ```typescript
 * const reasonFlowAnswers = getFeedbackReasonFlowAnswers(answers);
 * // Returns: [
 * //   { stepId: 'reason-selection', answer: ['collaboration-service'] },
 * //   { stepId: 'collaboration-service-type', answer: ['helping'] },
 * //   { stepId: 'collaboration-service-description', answer: 'They helped me with...' }
 * // ]
 *
 * // With translation and formatting:
 * const formattedAnswers = getFeedbackReasonFlowAnswers(
 *   answers,
 *   t,
 *   { selectedEmployee, formatDate }
 * );
 * // Returns: [
 * //   {
 * //     stepId: 'reason-selection',
 * //     answer: ['collaboration-service'],
 * //     formattedQuestion: 'What was the reason?',
 * //     formattedAnswer: 'Collaboration/Service'
 * //   },
 * //   ...
 * // ]
 * ```
 */
export const getFeedbackReasonFlowAnswers = (answers, translateFn, formatContext) => {
    return traverseReasonFlow(feedbackWizardFlow, answers, 'reason-selection', 'goal-selection', translateFn, formatContext);
};
